module.exports = __webpack_public_path__ + "img/contact_3.eb92541.png";